import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withMessages, useMessages } from '@ebsco-new-ui/messages';
import cn from 'classnames';

var CharacterCounter = function CharacterCounter(_ref) {
  var _ref$characterLimit = _ref.characterLimit,
    characterLimit = _ref$characterLimit === void 0 ? 0 : _ref$characterLimit,
    _ref$characterThresho = _ref.characterThreshold,
    characterThreshold = _ref$characterThresho === void 0 ? 0 : _ref$characterThresho,
    characterLength = _ref.characterLength;
  var messages = useMessages();
  var threshold = characterThreshold || characterLimit;
  var hasReachedThreshold = characterLimit && characterLength >= threshold;
  var characterCounterClass = cn("nuc-character-counter", hasReachedThreshold && "nuc-character-counter__threshold");
  var characterCounter = characterLimit ? "".concat(characterLength, "/").concat(characterLimit) : characterLength;
  var charactersRemaining = characterLimit - characterLength;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    "aria-hidden": "true",
    className: characterCounterClass
  }, characterCounter), /*#__PURE__*/React.createElement("div", {
    className: "nuc-character-counter__aria-live",
    "aria-live": "polite",
    "aria-atomic": true
  }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, messages.charactersRemaining, {
    values: {
      charactersRemaining: charactersRemaining
    }
  }))));
};
var characterCounter = withMessages(CharacterCounter);

export { CharacterCounter, characterCounter as default };
//# sourceMappingURL=character-counter-esm.js.map
